import type { ButtonHTMLAttributes, ReactNode } from "react";
import { Link, type LinkProps } from "react-router-dom";

export type ButtonVariant = "primary" | "secondary" | "ghost" | "urgent";
export type ButtonSize = "sm" | "md" | "lg";

interface ButtonStyle {
  variant?: ButtonVariant;
  size?: ButtonSize;
  block?: boolean;
  iconOnly?: boolean;
}

export function buttonClass({ variant = "primary", size = "md", block, iconOnly }: ButtonStyle = {}, extra = ""): string {
  return [
    "ds-btn",
    `ds-btn--${variant}`,
    size !== "md" ? `ds-btn--${size}` : "",
    block ? "ds-btn--block" : "",
    iconOnly ? "ds-icon-btn" : "",
    extra,
  ]
    .filter(Boolean)
    .join(" ");
}

export function Button({
  variant,
  size,
  block,
  iconOnly,
  className = "",
  type = "button",
  ...props
}: ButtonStyle & ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button type={type} className={buttonClass({ variant, size, block, iconOnly }, className)} {...props} />;
}

/** Internal navigation styled as a button (always a router <Link>, never <a href>). */
export function ButtonLink({
  variant,
  size,
  block,
  className = "",
  children,
  ...props
}: ButtonStyle & LinkProps & { children: ReactNode }) {
  return (
    <Link className={buttonClass({ variant, size, block }, className)} {...props}>
      {children}
    </Link>
  );
}
